import { ICreditorGroup } from "us.collection.admin/interfaces";

export const CreditorGroup: ICreditorGroup = {
    id: -1,
    groupName: "",
    activeStatus: true,
    description: "",
    numberOfCreditors: -1
}